import React from "react";

import { NavLink, useParams, useLoaderData } from "react-router-dom";

import Breadcrumbs from "./Breadcrumbs";
import AnswerBadges from "./AnswerBadges";
import ResetAnswersButton from "./ResetAnswersButton";

const TopicsPage = () => {
  let { categoryParam } = useParams();
  const {topics} = useLoaderData();

  {/*
  if (topics.length === 0) {
    return (
      <div>
        <Breadcrumbs category={categoryParam} />
        <main>
          <div className="alert alert-danger" role="alert">
            No such category {categoryParam}.
          </div>
        </main>
      </div>
    );
  }
*/}
  
  return (
    <div>
      <Breadcrumbs category={categoryParam} />
      <main>
        <div className="row g-0">
          <div className="col d-grid gap-2">
            <NavLink
              className="btn btn-outline-primary btn-block"
              to="quiz"
            >
              {`Start ${categoryParam} Quiz`}
            </NavLink>
          </div>
          <div className="col d-grid gap-2">
            <NavLink
              className="btn btn-outline-primary btn-block"
              to="exam"
            >
              {`Start ${categoryParam} Exam`}
            </NavLink>
          </div>
        </div>
        <div className="list-group list-group-flush">
          {topics.map((topic) => (
            <div
              key={topic}
              className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
            >
              <NavLink
                className="stretched-link text-dark"
                to={topic}
              >
                {topic}
              </NavLink>
              <AnswerBadges category={categoryParam} topic={topic} />
            </div>
          ))}
        </div>
        <ResetAnswersButton
          category={categoryParam}
          className="btn btn-block btn-outline-danger"
        />
      </main>
    </div>
  );
};

export default TopicsPage;
